import { Component, ViewEncapsulation, Input, Renderer2 } from '@angular/core';
import {
  FileContentModel,
  PreviewFileTypes
} from '../../../models/file-content.model';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

@Component({
  selector: 'app-preview-doc',
  templateUrl: './preview-doc.component.html',
  styleUrls: ['./preview-doc.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [PdfViewerModule, NgxDocViewerModule]
})
export class PreviewDocComponent {
  @Input() fileContentModel!: FileContentModel;
  viewerName = 'office';

  constructor(private renderer: Renderer2) {}

  checkIsImage(fileType: number) {
    return fileType === PreviewFileTypes.image;
  }
  checkIsPdf(fileType: number) {
    return fileType === PreviewFileTypes.pdf;
  }

  checkIsDoc(fileType: number) {
    return (
      fileType === PreviewFileTypes.doc || fileType === PreviewFileTypes.ppt
    );
  }

  checkIsUnSupportedFileType(fileType: number) {
    return fileType === PreviewFileTypes.unsupported;
  }

  open(): void {
    return;
  }

  close(): void {
    this.fileContentModel = {} as FileContentModel;
  }

  afterPdfLoadComplete(pdfData: any) {
    const totalPages = pdfData.numPages;
    const pdfElement = this.renderer.selectRootElement('#pdfViewer', true);
    if (pdfElement) {
      this.renderer.setStyle(pdfElement, 'height', `${totalPages * 1025}px`);
    }
  }
}
